import { isDemoClientId } from "@/lib/auth/demo";

/**
 * True when the current document is the decorative dashboard iframe on the landing
 * hero (`?embed=1` + a canonical demo client). That frame is `pointer-events-none`
 * and purely a product shot, so it must not boot analytics or auth: PostHog fires
 * fake dashboard pageviews from every landing visit, and the auth round-trip
 * (Supabase session + /api/auth/me) measured ~2.3s of the preview's load.
 *
 * Client-side only — reads `window.location`. Returns false during SSR, which is
 * the safe direction (the guarded work simply runs as it does today).
 *
 * Gated on the demo client id as well as `embed=1` so this can never be used to
 * render a real tenant's dashboard with auth skipped.
 */
export function isEmbedPreviewDocument(): boolean {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  return params.get("embed") === "1" && isDemoClientId(params.get("client_id"));
}
